export default __webpack_public_path__ + "static/media/discord_logo_white_outlined.8f7462f1.svg";